import { render, staticRenderFns } from "./PagePreviewModal.vue?vue&type=template&id=21c86d43&scoped=true"
import script from "./PagePreviewModal.vue?vue&type=script&lang=js"
export * from "./PagePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PagePreviewModal.vue?vue&type=style&index=0&id=21c86d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c86d43",
  null
  
)

export default component.exports